import { FC, PropsWithChildren } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { AnimatedBadge } from '../animated-badge';

type BadgeBannerProps = FC<
  PropsWithChildren<{ backgroundColor?: string; borderColor?: string; styles?: Interpolation<Theme> }>
>;

interface BadgeBannerNamespace extends BadgeBannerProps {
  AnimatedBadge: typeof AnimatedBadge;
  Title: typeof Title;
}

export const BadgeBanner: BadgeBannerNamespace = ({
  backgroundColor = theme.colors.secondary.seaweed5,
  borderColor = theme.colors.secondary.seaweed50,
  children,
  styles,
}) => {
  return <div css={[bannerStyles({ backgroundColor, borderColor }), styles]}>{children}</div>;
};

export const Title: FC<PropsWithChildren> = ({ children }) => {
  return <Text size='medium'>{children}</Text>;
};

BadgeBanner.Title = Title;
BadgeBanner.AnimatedBadge = AnimatedBadge;

const bannerStyles = ({ backgroundColor, borderColor }: { borderColor: string; backgroundColor: string }) =>
  css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.borderRadius.medium,
    backgroundColor: backgroundColor,
    border: `1px solid ${borderColor}`,
    width: 'fit-content',
  });
